import { create } from "zustand";

export interface CommonType {
  isShowInsight: boolean;
  setIsShowInsight: (isShowInsight: boolean) => void;

  isLoadedPage: boolean;
  setIsLoadedPage: (isLoadedPage: boolean) => void;

  dynamicInfoKey: string;
  setDynamicInfoKey: (dynamicInfoKey: string) => void;
  isShowModalDynamicInfo: boolean;
  setIsShowModalDynamicInfo: (isShowModalDynamicInfo: boolean) => void;

  alertTop: any;
  setAlertTop: (alertTop: any) => void;
  closeAlertTop: () => void;

  isDoneLoader: boolean;
  setIsDoneLoader: (isDoneLoader: boolean) => void;

  isShowEditionPanel: boolean;
  setIsShowEditionPanel: (isShowEditionPanel: boolean) => void;
  ctrlId: string;
  setCtrlId: (ctrlId: string) => void;
}

const useCommonStore = create<CommonType>((set) => ({
  isShowInsight: false,
  setIsShowInsight: (isShowInsight: boolean) => set(() => ({ isShowInsight })),

  isLoadedPage: false,
  setIsLoadedPage: (isLoadedPage: boolean) => set(() => ({ isLoadedPage })),

  dynamicInfoKey: "",
  setDynamicInfoKey: (dynamicInfoKey: string) =>
    set(() => ({ dynamicInfoKey })),
  isShowModalDynamicInfo: false,
  setIsShowModalDynamicInfo: (isShowModalDynamicInfo: boolean) =>
    set(() => ({ isShowModalDynamicInfo })),

  alertTop: null,
  setAlertTop: (alertTop: any) => set(() => ({ alertTop })),
  closeAlertTop: () => set(() => ({ alertTop: null })),

  isDoneLoader: false,
  setIsDoneLoader: (isDoneLoader: boolean) => set(() => ({ isDoneLoader })),

  isShowEditionPanel: false,
  setIsShowEditionPanel: (isShowEditionPanel: boolean) =>
    set(() => ({ isShowEditionPanel })),
  ctrlId: "",
  setCtrlId: (ctrlId: string) => set(() => ({ ctrlId })),
}));

export default useCommonStore;
